import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { AnswerSuggestion, GetSuggestion } from '../../fetchs';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 200,
  // },
});

class Suggestion extends Component {
  constructor(props){
    super(props);

    this.state = {
      suggestionId: '',
      answer: '',
      text: '',
      title: '',
      user: {},
      loading: false,
      saving: false
    }
  }

  componentDidMount() {
    const suggestionId = this.props.match.params.suggestionId;
    this.loadSuggestion(suggestionId);
  }

  loadSuggestion = (suggestionId) => {
    this.setState({loading: true});
    GetSuggestion(suggestionId)
        .then(response => {
            this.setState({loading: false});
            return response.json();
        })
        .then(responseJson => {
            this.setState({ 
                suggestionId: responseJson.suggestionId,
                answer: responseJson.answer,
                text: responseJson.text,
                title: responseJson.title,
                user: responseJson.user
            });
        })
        .catch(error => {
            this.setState({loading: false});
            console.log(error);
        });
  }

  handleSave = () => {
    AnswerSuggestion(this.state.suggestionId, this.state.answer)
      .then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/suggestions');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  render(){
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              اطلاعات کامل پیشنهاد
            </Typography>
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                        id="standard-first-name"
                        label="نام"
                        fullWidth
                        disabled
                        className={classes.textField}
                        value={this.state.user.firstName}
                        margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                        id="standard-last-name"
                        label="نام خانوادگی"
                        fullWidth
                        disabled
                        className={classes.textField}
                        value={this.state.user.lastName}
                        margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                        id="standard-title"
                        label="عنوان"
                        fullWidth
                        disabled
                        className={classes.textField}
                        value={this.state.title}
                        margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                        id="standard-text"
                        label="متن پیشنهاد"
                        fullWidth
                        disabled
                        className={classes.textField}
                        value={this.state.text}
                        multiline
                        rows="4"
                        margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                        id="standard-answer"
                        label="پاسخ"
                        fullWidth
                        className={classes.textField}
                        value={this.state.answer}
                        multiline
                        rows="4"
                        onChange={this.handleChange('answer')}
                        margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    fullWidth 
                    disabled={this.state.loading}
                    onClick={this.handleSave}>ذخیره</Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

Suggestion.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Suggestion));
